<template>
  <div style="margin: 10px;">
    <a-card size="small" hoverable>
      <h5 slot="title">
        {{ cardTitle }} <em>({{ usersCount }})</em>
      </h5>
      <a-button
        slot="extra"
        type="normal"
        icon="plus"
        @click="() => (visibleDrawer = !visibleDrawer)"
      >
        Add users
      </a-button>
      <Scrollbar style="max-height: 400px;">
        <a-list
          item-layout="horizontal"
          :data-source="leadersAndManagersApproval.users"
          :loading="loadingList"
          size="small"
        >
          <a-list-item slot="renderItem" slot-scope="user, index">
            <a-list-item-meta>
              <a slot="title" href="#"
                >{{ index + 1 }}. {{ user.fullname || user.username }}</a
              >
              <a-icon type="user" slot="avatar" />
              <div slot="description">
                <span v-if="user.position">{{ user.position.name }}</span>
                <span v-if="user.position && user.department"> / </span>
                <span v-if="user.department">{{ user.department.name }}</span>
              </div>
            </a-list-item-meta>
            <a-button
              type="danger"
              shape="circle"
              icon="minus"
              @click="removeUserFromUserGroupSys(user.id)"
              :loading="removing"
              size="small"
              style="margin-right: 10px;"
            />
            <!--          <a slot="actions" @click="() => {}"-->
            <!--            ><a-icon type="user-delete" style="color: red; font-size: 20px;"-->
            <!--          /></a>-->
          </a-list-item>
        </a-list>
      </Scrollbar>
    </a-card>

    <a-drawer
      title="Select users"
      placement="right"
      :closable="false"
      :visible="visibleDrawer"
      @close="onCloseDrawer"
    >
      <AddNewUserDrawer
        :id="leadersAndManagersApproval.id"
        :onCloseDrawer="onCloseDrawer"
        :updateListUser="updateListUser"
      />
    </a-drawer>
  </div>
</template>
<script>
import {
  getDetailUserGroupSysByName,
  removeUserFromUserGroupSys,
} from "@/views/configAdmin/list-permission/query.service";

export default {
  components: {
    AddNewUserDrawer: () => import("./AddNewUserDrawer"),
    Scrollbar: () => import("vue-custom-scrollbar"),
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visibleDrawer: false,
      leadersAndManagersApproval: {},
      removing: false,
      loadingList: false,
    };
  },
  methods: {
    onCloseDrawer() {
      this.visibleDrawer = false;
    },
    updateListUser(users) {
      if (!users || users.length === 0) {
        this.$set(this.leadersAndManagersApproval, "users", []);
        return;
      }

      this.$set(this.leadersAndManagersApproval, "users", users);
    },
    removeUserFromUserGroupSys(userId) {
      if (userId && userId.trim()) {
        this.removing = true;

        const params = {
          id: this.leadersAndManagersApproval.id,
          removeUserId: userId,
        };

        removeUserFromUserGroupSys(params)
          .then(({ data }) => {
            this.removing = false;
            if (data.removeUserFromUserGroupSys?.users) {
              this.updateListUser(data.removeUserFromUserGroupSys.users);
            }
          })
          .catch((e) => {
            this.removing = false;
            this.$message.error("Lỗi! không thể xoá user ra");
            console.log("e", e);
          });
      }
    },
  },
  computed: {
    usersCount() {
      if (this.leadersAndManagersApproval?.users) {
        return this.leadersAndManagersApproval.users.length;
      }
      return 0;
    },
  },
  created() {
    this.loadingList = true;

    getDetailUserGroupSysByName(this.name)
      .then(({ data }) => {
        this.loadingList = false;
        this.leadersAndManagersApproval = data.getDetailUserGroupSysByName;
      })
      .catch((e) => {
        this.loadingList = false;
        console.log("E", e);
        this.$message.error("Lỗi không thể lấy được danh sách");
      });
  },
};
</script>
